const talentLang = {
  en: {
    placeApplicant: "Place applicant",
    departamentAplicant: "Department applicant",
    firstName: "First name",
    secondName: "Second name",
    thirdName: "Third name",
    paternalLastname: "Paternal lastname",
    maternalLastname: "Maternal lastname",
    marriedName: "Married name",
    personalEmail: "Personal e-mail",
    vocationalInformation: "Vocational information",
    workInformation: "Work information",
    familyReferences: "Family references",
    supportDocumentation: "Support documentation",
    back: "Back",
    continue: "Continue",
    birthday: "Birthday",
    gender: "Gender",
    extended: "Extended",
    dateExpireDpi: "Date expire DPI",
    profession: "Profession",
    collegiateNumber: "Collegiate number",
    dateExpireCollegiate: "Date expire collegiate",
    countryResidence: "Country residence",
    departamentResidence: "Departament residence",
    cityResidence: "City residence",
    homePhone: "Home phone",
    home_phone: "Home phone",
    personalPhone: "Personal phone",
    licenses: "Licenses",
    licenseNumber: "License number",
    licenseType: "License type",
    studies: "Studies",
    gradeObtained: "Grade obtained",
    degreeYear: "Year",
    titleDegree: "Title",
    centerName: "Center name",
    levelWritten: "Level written",
    levelSpoken: "Level spoken",
    works: "Works",
    companyName: "Company name",
    position: "Position",
    otherCharges: "Other charges",
    nameReference: "Name reference",
    relationship: "Relationship",
    ageReference: "Age",
    emergencyContact: "Emergency contact",
    nameAttachment: "Name attachment",
    basic: "Basic",
    middle: "Middle",
    advanced: "Advanced",
    native: "Native",
    dateEntry: "Date entry",
    companyPhone: "Company phone",
    startingSalary: "Starting salary",
    reasonExit: "Reason exit",
    companyContribution: "What was your biggest contribution to the company?",
    dateOut: "Date out",
    dependents: "Dependents",
    finalSalary: "Final salary",
    reasonExitDescription: "Reason exit description",
    companyLike: "What did you like most about the company?",
    functions: "Functions",
    immediateBoss: "Immediate boss",
    referencesRequest: "Can references be requested?",
    availability: "Availavility",
    companyDislike: "What did you like least about the company?",
    resignation: "Resignation",
    dismissal: "Dismissal",
    other: "Other",
    immediate: "Immediate",
    less_week: "Lees week",
    week: "Week",
    send: "Send",
    fifteen_days: "Fifteen days",
    more_fifteen_days: "More fifteen days",
    workPlace: "Work place",
    phoneReference: "Phone",
    professionReference: "Profession",
    database: "Database",
    note: "Note",
    identification_document: "Identification document",
    extended_in: "Extended in",
    sendMail: "Send mail",
    applicant: "Applicant",
    applicantModified: "Modified by applicant",
    institutional_connections: "Instutional connections",
    knows_someone_at_rdn: "Knows someone at SBS?",
    seen: "Seen",
    considerate: "To considerate",
    hired: "Hired",
    discharged: "Discharged",
    idApplicant: "Applicant ID",
    changeStatus: "Change status",
    talent: "Human talent",
    applicants: "Applicants",
    statusChanges: "Status changes",
    mail_send: "Mail send",
    collaborators: "Collaborators",
    collaboratorSince: "Collaborator since",
    info_insert_succesful:
      "The information has been added successfully",
    sureSave:
      "Are you sure to submit the information?",
    info_updated_successful:
      "The information has been updated successfully",
    info_send_application_failure:
      "Your application has not been sent because there is another application with the same information",
    // Traducciones específicas de colaboradores
    searchByName: "Search by name",
    searchByNameDPI: "Search by name or DPI",
    clear: "Clear",
    aYearAgo: "A year ago",
    names: "Names",
    lastNames: "Last names",
    place: "Place",
    phone: "Phone",
    department: "Department",
    // Personal Information
    firstname: "First name",
    secondname: "Second name",
    thirdname: "Third name",
    extendedIn: "Extended in",
    dpiExpirationDate: "DPI expiration date",
    nit: "NIT",
    igssNumber: "IGSS number",
    civilStatus: "Civil status",
    ethnicGroup: "Ethnic group",
    isFather: "Is father",
    isMother: "Is mother",
    country: "Country",
    city: "City",
    livingPlace: "Living place",
    religion: "Religion",
    cellPhone: "Cell phone",
    // Financial Information
    financialInformation: "Financial information",
    otherIncome: "Other income",
    approximateAmount: "Approximate amount",
    incomeSource: "Income source",
    debtsAndAmount: "Debts and amount",
    // Medical Information
    medicalInformation: "Medical information",
    bloodType: "Blood type",
    anyDisease: "Any disease?",
    diseaseDescription: "Disease description",
    illnessLastYears: "Illness last years",
    illnessDescription: "Illness description",
    physicalHandicap: "Physical handicap",
    handicapDescription: "Handicap description",
    retired: "Retired",
    retirementCompany: "Retirement company",
    // Vocational Information
    professionalInformation: "Professional information",
    collegiateExpirationDate: "Collegiate expiration date",
    educationalInformation: "Educational information",
    educationRecord: "Education record",
    studyField: "Study field",
    educationCenter: "Education center",
    graduationYear: "Graduation year",
    degree: "Degree",
    addEducation: "Add education",
    languageInformation: "Language information",
    languageName: "Language name",
    writtenLevel: "Written level",
    spokenLevel: "Spoken level",
    addLanguage: "Add language",
    driverLicenseInformation: "Driver license information",
    license: "License",
    addLicense: "Add license",
    // Work Information
    workExperience: "Work experience",
    experienceRecord: "Experience record",
    currentJob: "Current job",
    otherPositions: "Other positions",
    departureReason: "Departure reason",
    departureReasonDescription: "Departure reason description",
    whatDidYouLike: "What did you like?",
    whatDidYouDislike: "What did you dislike?",
    addWorkExperience: "Add work experience",
    // Family References
    personalReferences: "Personal references",
    referenceRecord: "Reference record",
    occupation: "Occupation",
    addReference: "Add reference",
    familyInformation: "Family information",
    familyMember: "Family member",
    addFamilyMember: "Add family member",
    // Support Documentation
    uploadFiles: "Upload files",
    supportedFileTypes: "Supported file types",
    dropFileHereOrClick: "Drop file here or click",
    documentType: "Document type",
    documentName: "Document name",
    fileName: "File name",
    fileSize: "File size",
    uploadDate: "Upload date",
    uploadDocument: "Upload document",
    upload: "Upload",
    uploaded: "Uploaded",
    download: "Download",
    noDocumentsFound: "No documents found",
    fileCannotBePreviewedDownloadInstead: "File cannot be previewed, download instead",
    confirmDeleteFile: "Confirm delete file?",
    requiredDocuments: "Required documents",
    additionalDocuments: "Additional documents",
    uploadAdditionalFile: "Upload additional file",
    noAdditionalDocumentsFound: "No additional documents found",
    // Institutional Access
    institutionalAccess: "Institutional access",
    systemAccess: "System access",
    noSystemAccess: "No system access",
    institutionalEmail: "Institutional email",
    institutionalUsername: "Institutional username",
    user: "User",
    role: "Role",
    resetPassword: "Reset password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    createSystemUser: "Create system user",
    // Status Changes
    statusHistory: "Status history",
    statusChangeDetails: "Status change details",
    changedBy: "Changed by",
    reason: "Reason",
    noStatusChangesFound: "No status changes found",
    // Departure
    dateDeparture: "Date departure",
    noteDeparture: "Note departure",
    // Contracts
    contracts: "Contracts",
    contract: "Contract",
    addContract: "Add contract",
    addFirstContract: "Add first contract",
    noContracts: "No contracts",
    contractNumber: "Contract number",
    cooperating: "Cooperating",
    salary: "Salary",
    bonification: "Bonification",
    employerFee: "Employer fee",
    benefits: "Benefits",
    isr: "ISR",
    expired: "Expired",
    editContract: "Edit contract",
    newContract: "New contract",
    associatedPlanifications: "Associated planifications",
    noPlanificationsAssociated: "No planifications associated",
    associatePlanification: "Associate planification",
    planification: "Planification",
    planificationId: "Planification ID",
    planificationDetails: "Planification details",
    paymentType: "Payment type",
    addPlanification: "Add planification",
    noAssociatedPlanifications: "No associated planifications",
    associate: "Associate",
    // Permissions
    permissions: "Permissions",
    seePermissions: "See permissions",
    admin: "Admin",
    canRead: "Can read",
    canWrite: "Can write",
    users: "Users",
    addUser: "Add user",
    requestPermission: "Request permission",
    userPermissions: "User permissions",
    systemPermissions: "System permissions",
    rolePermissions: "Role permissions",
    savePermissions: "Save permissions",
    // Care Received
    careReceived: "Care received",
    addCareReceived: "Add care received",
    activityDate: "Activity date",
    logicFrame: "Logic frame",
    task: "Task",
    headquarter: "Residence / Program",
    headquarters: "Residence / Program",
    report: "Report",
    // Other
    details: "Details",
    comments: "Comments",
    noComments: "No comments",
    create: "Create",
    notSpecified: "Not specified",
    pending: "Pending",
    evaluation: "Evaluation",
    fullName: "Full name",
    state: "State",
    town: "Town",
    community: "Community",
    line: "Line",
    vehicleType: "Vehicle type",
    brand: "Brand",
    transport: "Transport",
    transportInformation: "Transport information",
    addTransport: "Add transport",
    internalConnections: "Acquaintances within the institution",
    noConnectionsFound: "No acquaintances found",
    addConnection: "Add acquaintance",
    editConnection: "Edit acquaintance",
    confirmDeleteConnection: "Confirm delete acquaintance?",
    enterLinkedPerson: "Enter linked person",
    createPerson: "Create person",
    rescuedPerson: "Rescued person",
    removeBond: "Remove bond",
    addOffender: "Add offender",
    court: "Court",
    reasonAdmission: "Reason admission",
    referrer: "Referrer",
    areYouPregnant: "Are you pregnant?",
    explainYourAnswer: "Explain your answer",
    thematic: "Thematic",
    thematicDivision: "Thematic division",
    numberOfExternalFiles: "Number of external files",
    fifteenDays: "Fifteen days",
    moreThanFifteenDays: "More than fifteen days",
    lessThanAWeek: "Less than a week",
    oneWeek: "One week",
    // Traducciones adicionales faltantes
    idCollaborator: "Collaborator ID",
    terminateCollaborator: "Terminate collaborator",
    companyType: "Company type",
    select: "Select",
    terminated: "Terminated",
    reviewed: "Reviewed",
    consideration: "Consideration",
    noData: "No data",
    // Estado civil
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    separated: "Separated",
    // Contratos
    endOfContract: "End of contract",
    retirement: "Retirement",
    // Mensajes de error
    errorSavingData: "Error saving data",
    dataSavedSuccessfully: "Data saved successfully",
    errorLoadingCollaborator: "Error loading collaborator",
    noPermissionToViewProfile: "You don't have permission to view this profile",
    // Document types
    idCard: "ID Card",
    idCardDescription: "National identification card (both sides)",
    passport: "Passport",
    resume: "Resume/CV",
    resumeDescription: "Professional resume or curriculum vitae",
    academicDegree: "Academic Degree",
    academicDegreeDescription: "University degrees and diplomas",
    collegiateCard: "Professional License Card",
    collegiateActive: "Active Professional License",
    collegiateActiveDescription: "Current professional license registration",
    professionalLicense: "Professional License",
    driverLicense: "Driver's License",
    driverLicenseDescription: "Driver's license (both sides, for drivers)",
    bankAccountCertificate: "Bank Account Certificate",
    bankAccountDescription: "Bank account ownership certificate",
    policeRecord: "Police Record",
    policeRecordDescription: "Criminal background check from police",
    criminalRecord: "Criminal Record",
    criminalRecordDescription: "Criminal history certificate",
    medicalCertificate: "Medical Certificate",
    medicalCertificateDescription: "Health clearance certificate",
    rtu: "RTU",
    rtuDescription: "Unified Tax Registry",
    renas: "RENAS",
    renasDescription: "National Registry of Non-Profit Associations",
    psea: "PSEA",
    pseaDescription: "Protection from Sexual Exploitation and Abuse certification",
    utilityBill: "Utility Bill",
    utilityBillDescription: "Water, electricity or phone bill with current address",
    ornamentTicket: "Ornament Ticket",
    ornamentTicketDescription: "Municipal ornament ticket",
    titlesAndDiplomas: "Titles and Diplomas",
    titlesAndDiplomasDescription: "Academic titles and diplomas",
    fileUploadedSuccessfully: "File uploaded successfully",
    pleaseSelectFile: "Please select a file",
    errorSavingDocuments: "Error saving documents",
    invalidFileType: "Invalid file type. Please upload only JPG, JPEG, PNG, or PDF files",
    uploadingFile: "Uploading file",
    errorUploadingFile: "Error uploading file",
    // User creation
    createUser: "Create User",
    createUserForCollaborator: "Create User for Collaborator",
    passwordsDoNotMatch: "Passwords do not match",
    userCreatedSuccessfully: "User created successfully",
    errorCreatingUser: "Error creating user",
    // Additional messages
    unsavedChanges: "Unsaved changes",
    unsavedChangesMessage: "You have unsaved changes. Do you want to save them before continuing?",
    discardChanges: "Discard changes",
    // Connection messages
    connection: "Acquaintance",
    connectionAddedSuccessfully: "Acquaintance added successfully",
    connectionSavedSuccessfully: "Acquaintance saved successfully",
    connectionDeletedSuccessfully: "Acquaintance deleted successfully",
    errorSavingConnection: "Error saving acquaintance",
    errorDeletingConnection: "Error deleting acquaintance",
    pleaseCompleteAllFields: "Please complete all fields",
    usernameAvailable: "Username available",
    usernameNotAvailable: "Username not available",
    institutionalDataSaved: "Institutional data saved successfully",
    permissionsSavedSuccessfully: "Permissions saved successfully",
    errorSavingPermissions: "Error saving permissions",
    pleaseCompleteRequiredFields: "Please complete required fields",
  },
  es: {
    placeApplicant: "Plaza aplicación",
    departamentAplicant: "Departamento aplicación",
    firstName: "Primer nombre",
    secondName: "Segundo nombre",
    thirdName: "Tercer nombre",
    paternalLastname: "Apellido paterno",
    maternalLastname: "Apellido materno",
    marriedName: "Apellido de casada",
    personalEmail: "Correo electrónico personal",
    vocationalInformation: "Información vocacional",
    workInformation: "Información laboral",
    familyReferences: "Referencias familiares",
    supportDocumentation: "Documentación de soporte",
    back: "Atrás",
    continue: "Continuar",
    birthday: "Fecha de nacimiento",
    gender: "Género",
    extended: "Extendido",
    dateExpireDpi: "Fecha expiración DPI",
    profession: "Profesión",
    collegiateNumber: "Número colegiado",
    dateExpireCollegiate: "Fecha expiración número colegiado",
    countryResidence: "País residencia",
    departamentResidence: "Departamento residencia",
    cityResidence: "Municipio residencia",
    homePhone: "Teléfono casa",
    home_phone: "Teléfono casa",
    personalPhone: "Teléfono personal",
    licenses: "Licencias",
    licenseNumber: "Número licencia",
    licenseType: "Tipo licencia",
    studies: "Estudios",
    gradeObtained: "Grado obtenido",
    degreeYear: "Año",
    titleDegree: "Título",
    centerName: "Nombre centro",
    levelWritten: "Nivel escritura",
    levelSpoken: "Nivel hablado",
    works: "Trabajos",
    companyName: "Nombre empresa",
    position: "Puesto",
    otherCharges: "Otros cargos",
    nameReference: "Nombre referencia",
    relationship: "Relación",
    ageReference: "Edad",
    emergencyContact: "Contacto emergencia",
    nameAttachment: "Nombre adjunto",
    basic: "Básico",
    middle: "Intermedio",
    advanced: "Avanzado",
    native: "Nativo",
    dateEntry: "Fecha ingreso",
    companyPhone: "Teléfono",
    startingSalary: "Salario inicial",
    reasonExit: "Motivo salida",
    companyContribution: "¿Cuál fue su mayor aporte a la empresa?",
    dateOut: "Fecha salida",
    dependents: "Personas a cargo",
    finalSalary: "Salario final",
    reasonExitDescription: "Descripción motivo salida",
    companyLike: "Lo que más le agradaba de la empresa",
    functions: "Funciones",
    immediateBoss: "Jefe inmediato",
    referencesRequest: "¿Se pueden solicitar referencias?",
    availability: "Disponibilidad",
    companyDislike: "Lo que menos le agradaba de la empresa",
    resignation: "Renuncia",
    dismissal: "Despido",
    other: "Otro",
    immediate: "Inmediato",
    less_week: "Menos de una semana",
    week: "Semana",
    send: "Enviar",
    fifteen_days: "15 días",
    more_fifteen_days: "Más de 15 días",
    workPlace: "Lugar de trabajo",
    phoneReference: "Teléfono",
    professionReference: "Profesión",
    database: "Base de datos",
    note: "Nota",
    identification_document: "Documento de identificación",
    extended_in: "Extendido en",
    sendMail: "Enviar correo",
    applicant: "Aplicante",
    applicantModified: "Modificado por aplicante",
    institutional_connections: "Conexiones institucionales",
    knows_someone_at_rdn: "¿Conoce a alguien en SBS?",
    seen: "Visto",
    considerate: "A considerar",
    hired: "Contratado",
    discharged: "De baja",
    idApplicant: "ID aplicante",
    changeStatus: "Cambiar estado",
    talent: "Talento humano",
    applicants: "Aplicantes",
    statusChanges: "Cambios de estado",
    mail_send: "Correo enviado",
    collaborators: "Colaboradores",
    collaboratorSince: "Colaborador desde",
    info_insert_succesful:
        "La información ha sido agregada exitosamente",
    sureSave:
        "¿Está seguro de enviar la información?",
    info_updated_successful:
        "La información ha sido actualizada exitosamente",
    info_send_application_failure:
        "Su solicitud no ha sido enviada porque existe otra solicitud con la misma información",
    // Traducciones específicas de colaboradores
    searchByName: "Buscar por nombre",
    searchByNameDPI: "Buscar por nombre o DPI",
    clear: "Limpiar",
    aYearAgo: "Hace un año",
    names: "Nombres",
    lastNames: "Apellidos",
    place: "Plaza",
    phone: "Teléfono",
    department: "Departamento",
    // Información Personal
    firstname: "Primer nombre",
    secondname: "Segundo nombre",
    thirdname: "Tercer nombre",
    extendedIn: "Extendido en",
    dpiExpirationDate: "Fecha vencimiento DPI",
    nit: "NIT",
    igssNumber: "Número IGSS",
    civilStatus: "Estado civil",
    ethnicGroup: "Grupo étnico",
    isFather: "Es padre",
    isMother: "Es madre",
    country: "País",
    city: "Ciudad",
    livingPlace: "Lugar de residencia",
    religion: "Religión",
    cellPhone: "Teléfono celular",
    // Información Financiera
    financialInformation: "Información financiera",
    otherIncome: "Otros ingresos",
    approximateAmount: "Monto aproximado",
    incomeSource: "Fuente de ingresos",
    debtsAndAmount: "Deudas y monto",
    // Información Médica
    medicalInformation: "Información médica",
    bloodType: "Tipo de sangre",
    anyDisease: "¿Alguna enfermedad?",
    diseaseDescription: "Descripción de enfermedad",
    illnessLastYears: "Enfermedad últimos años",
    illnessDescription: "Descripción de enfermedad",
    physicalHandicap: "Discapacidad física",
    handicapDescription: "Descripción de discapacidad",
    retired: "Jubilado",
    retirementCompany: "Empresa de jubilación",
    // Información Vocacional
    professionalInformation: "Información profesional",
    collegiateExpirationDate: "Fecha vencimiento colegiado",
    educationalInformation: "Información educativa",
    educationRecord: "Registro educativo",
    studyField: "Campo de estudio",
    educationCenter: "Centro educativo",
    graduationYear: "Año de graduación",
    degree: "Título",
    addEducation: "Agregar educación",
    languageInformation: "Información de idiomas",
    languageName: "Nombre del idioma",
    writtenLevel: "Nivel escrito",
    spokenLevel: "Nivel hablado",
    addLanguage: "Agregar idioma",
    driverLicenseInformation: "Información de licencia de conducir",
    license: "Licencia",
    addLicense: "Agregar licencia",
    // Información Laboral
    workExperience: "Experiencia laboral",
    experienceRecord: "Registro de experiencia",
    currentJob: "Trabajo actual",
    otherPositions: "Otros cargos",
    departureReason: "Razón de salida",
    departureReasonDescription: "Descripción razón de salida",
    whatDidYouLike: "¿Qué le agradaba?",
    whatDidYouDislike: "¿Qué le desagradaba?",
    addWorkExperience: "Agregar experiencia laboral",
    // Referencias Familiares
    personalReferences: "Referencias personales",
    referenceRecord: "Registro de referencia",
    occupation: "Ocupación",
    addReference: "Agregar referencia",
    familyInformation: "Información familiar",
    familyMember: "Miembro familiar",
    addFamilyMember: "Agregar miembro familiar",
    // Documentación de Soporte
    uploadFiles: "Subir archivos",
    supportedFileTypes: "Tipos de archivo soportados",
    dropFileHereOrClick: "Suelte el archivo aquí o haga clic",
    documentType: "Tipo de documento",
    documentName: "Nombre del documento",
    fileName: "Nombre de archivo",
    fileSize: "Tamaño de archivo",
    uploadDate: "Fecha de carga",
    uploadDocument: "Subir documento",
    upload: "Subir",
    uploaded: "Subido",
    download: "Descargar",
    noDocumentsFound: "No se encontraron documentos",
    fileCannotBePreviewedDownloadInstead: "El archivo no se puede previsualizar, descárguelo",
    confirmDeleteFile: "¿Confirmar eliminar archivo?",
    requiredDocuments: "Documentos requeridos",
    additionalDocuments: "Documentos adicionales",
    uploadAdditionalFile: "Subir archivo adicional",
    noAdditionalDocumentsFound: "No se encontraron documentos adicionales",
    // Acceso Institucional
    institutionalAccess: "Acceso institucional",
    systemAccess: "Acceso al sistema",
    noSystemAccess: "Sin acceso al sistema",
    institutionalEmail: "Correo institucional",
    institutionalUsername: "Usuario institucional",
    user: "Usuario",
    role: "Rol",
    resetPassword: "Restablecer contraseña",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    createSystemUser: "Crear usuario del sistema",
    // Cambios de Estado
    statusHistory: "Historial de estado",
    statusChangeDetails: "Detalles de cambio de estado",
    changedBy: "Cambiado por",
    reason: "Razón",
    noStatusChangesFound: "No se encontraron cambios de estado",
    // Salida
    dateDeparture: "Fecha de salida",
    noteDeparture: "Nota de salida",
    // Contratos
    contracts: "Contratos",
    contract: "Contrato",
    addContract: "Agregar contrato",
    addFirstContract: "Agregar primer contrato",
    noContracts: "Sin contratos",
    contractNumber: "Número de contrato",
    cooperating: "Cooperante",
    salary: "Salario",
    bonification: "Bonificación",
    employerFee: "Cuota patronal",
    benefits: "Beneficios",
    isr: "ISR",
    expired: "Vencido",
    editContract: "Editar contrato",
    newContract: "Nuevo contrato",
    associatedPlanifications: "Planificaciones asociadas",
    noPlanificationsAssociated: "Sin planificaciones asociadas",
    associatePlanification: "Asociar planificación",
    planification: "Planificación",
    planificationId: "ID de planificación",
    planificationDetails: "Detalles de planificación",
    paymentType: "Tipo de pago",
    addPlanification: "Agregar planificación",
    noAssociatedPlanifications: "Sin planificaciones asociadas",
    associate: "Asociar",
    // Permisos
    permissions: "Permisos",
    seePermissions: "Ver permisos",
    admin: "Administrador",
    canRead: "Puede leer",
    canWrite: "Puede escribir",
    users: "Usuarios",
    addUser: "Agregar usuario",
    requestPermission: "Solicitar permiso",
    userPermissions: "Permisos de usuario",
    systemPermissions: "Permisos del sistema",
    rolePermissions: "Permisos del rol",
    savePermissions: "Guardar permisos",
    // Atención Recibida
    careReceived: "Atención recibida",
    addCareReceived: "Agregar atención recibida",
    activityDate: "Fecha de actividad",
    logicFrame: "Marco lógico",
    task: "Tarea",
    headquarter: "Residencia / Programa",
    headquarters: "Residencia / Programa",
    report: "Reporte",
    // Otros
    details: "Detalles",
    comments: "Comentarios",
    noComments: "Sin comentarios",
    create: "Crear",
    notSpecified: "No especificado",
    pending: "Pendiente",
    evaluation: "Evaluación",
    fullName: "Nombre completo",
    state: "Estado/Departamento",
    town: "Municipio",
    community: "Comunidad",
    line: "Línea",
    vehicleType: "Tipo de vehículo",
    brand: "Marca",
    transport: "Transporte",
    transportInformation: "Información de transporte",
    addTransport: "Agregar transporte",
    internalConnections: "Conocidos dentro de la institución",
    noConnectionsFound: "No se encontraron conocidos",
    addConnection: "Agregar conocido",
    editConnection: "Editar conocido",
    confirmDeleteConnection: "¿Confirmar eliminar conocido?",
    enterLinkedPerson: "Ingresar persona vinculada",
    createPerson: "Crear persona",
    rescuedPerson: "Persona rescatada",
    removeBond: "Remover vínculo",
    addOffender: "Agregar victimario",
    court: "Juzgado",
    reasonAdmission: "Razón de admisión",
    referrer: "Referente",
    areYouPregnant: "¿Está embarazada?",
    explainYourAnswer: "Explique su respuesta",
    thematic: "Eje temático",
    thematicDivision: "División temática",
    numberOfExternalFiles: "Número de archivos externos",
    fifteenDays: "Quince días",
    moreThanFifteenDays: "Más de quince días",
    lessThanAWeek: "Menos de una semana",
    oneWeek: "Una semana",
    // Traducciones adicionales faltantes
    idCollaborator: "ID de colaborador",
    terminateCollaborator: "Dar de baja colaborador",
    companyType: "Tipo de empresa",
    select: "Seleccionar",
    terminated: "Dado de baja",
    reviewed: "Revisado",
    consideration: "Consideración",
    noData: "Sin datos",
    // Estado civil
    single: "Soltero/a",
    married: "Casado/a",
    divorced: "Divorciado/a",
    widowed: "Viudo/a",
    separated: "Separado/a",
    // Contratos
    endOfContract: "Fin de contrato",
    retirement: "Jubilación",
    // Mensajes de error
    errorSavingData: "Error al guardar los datos",
    dataSavedSuccessfully: "Datos guardados exitosamente",
    noPermissionToViewProfile: "No tiene permiso para ver este perfil",
    errorLoadingCollaborator: "Error al cargar el colaborador",
    // Tipos de documento
    idCard: "DPI",
    idCardDescription: "DPI (ambos lados)",
    passport: "Pasaporte",
    resume: "Hoja de Vida",
    resumeDescription: "Hoja de vida o currículum profesional",
    academicDegree: "Título Académico",
    academicDegreeDescription: "Títulos universitarios y diplomas",
    collegiateCard: "Carnet de Colegiado",
    collegiateActive: "Colegiado Activo",
    collegiateActiveDescription: "Constancia de colegiado activo",
    professionalLicense: "Licencia Profesional",
    driverLicense: "Licencia de Conducir",
    driverLicenseDescription: "Licencia de conducir (ambos lados, en caso de pilotos)",
    bankAccountCertificate: "Certificado de Cuenta Bancaria",
    bankAccountDescription: "Certificado de titularidad de cuenta bancaria",
    policeRecord: "Antecedentes Policíacos",
    policeRecordDescription: "Certificado de antecedentes policíacos",
    criminalRecord: "Antecedentes Penales",
    criminalRecordDescription: "Certificado de antecedentes penales",
    medicalCertificate: "Certificado Médico",
    medicalCertificateDescription: "Certificado de salud",
    rtu: "RTU",
    rtuDescription: "Registro Tributario Unificado",
    renas: "RENAS",
    renasDescription: "Registro Nacional de Asociaciones Sin Fines de Lucro",
    psea: "PSEA",
    pseaDescription: "Certificación de Protección contra Explotación y Abuso Sexual",
    utilityBill: "Factura de Servicio",
    utilityBillDescription: "Factura de agua, luz o teléfono con dirección de residencia actual",
    ornamentTicket: "Boleto de Ornato",
    ornamentTicketDescription: "Boleto de ornato municipal",
    titlesAndDiplomas: "Títulos y Diplomas",
    titlesAndDiplomasDescription: "Títulos y diplomas académicos",
    fileUploadedSuccessfully: "Archivo subido exitosamente",
    pleaseSelectFile: "Por favor seleccione un archivo",
    errorSavingDocuments: "Error al guardar los documentos",
    invalidFileType: "Tipo de archivo inválido. Por favor suba solo archivos JPG, JPEG, PNG o PDF",
    uploadingFile: "Subiendo archivo",
    errorUploadingFile: "Error al subir el archivo",
    // Creación de usuario
    createUser: "Crear Usuario",
    createUserForCollaborator: "Crear Usuario para Colaborador",
    passwordsDoNotMatch: "Las contraseñas no coinciden",
    userCreatedSuccessfully: "Usuario creado exitosamente",
    errorCreatingUser: "Error al crear usuario",
    // Mensajes adicionales
    unsavedChanges: "Cambios sin guardar",
    unsavedChangesMessage: "Tienes cambios sin guardar. ¿Deseas guardarlos antes de continuar?",
    discardChanges: "Descartar cambios",
    // Mensajes de conexiones
    connection: "Conocido",
    connectionAddedSuccessfully: "Conocido agregado exitosamente",
    connectionSavedSuccessfully: "Conocido guardado exitosamente",
    connectionDeletedSuccessfully: "Conocido eliminado exitosamente",
    errorSavingConnection: "Error al guardar el conocido",
    errorDeletingConnection: "Error al eliminar el conocido",
    pleaseCompleteAllFields: "Por favor complete todos los campos",
    usernameAvailable: "Usuario disponible",
    usernameNotAvailable: "Usuario no disponible",
    institutionalDataSaved: "Datos institucionales guardados exitosamente",
    permissionsSavedSuccessfully: "Permisos guardados exitosamente",
    errorSavingPermissions: "Error al guardar permisos",
    pleaseCompleteRequiredFields: "Por favor complete los campos requeridos",
  },
};
export default talentLang;
